import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-693c123e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slot" }, "Učitavamo dostupne termine...", -1))
const _hoisted_2 = { class: "slot" }
const _hoisted_3 = { class: "start-on" }
const _hoisted_4 = { class: "start-time" }
const _hoisted_5 = { class: "state" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Raspored predavanja", -1))
const _hoisted_9 = { class: "schedule" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Prijavi se", -1))
const _hoisted_12 = ["onSubmit"]
const _hoisted_13 = { class: "fields" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "form-name" }, "Ime:", -1))
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "error"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "form-surname" }, "Prezime:", -1))
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 1,
  class: "error"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "form-phone-number" }, "Telefon:", -1))
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 2,
  class: "error"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "form-driving-school" }, "Autoškola:", -1))
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  key: 3,
  class: "error"
}
const _hoisted_26 = { class: "form-btn" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = {
  key: 4,
  class: "error"
}
const _hoisted_31 = {
  key: 0,
  class: "error"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slot" }, "Trenutno nemamo dostupnih termina", -1))

import { AxiosStatic } from "axios";
import { computed, inject, ref } from "vue";
import { getClasses, bookClass } from "../api";
import { Class, ClassState } from "@/interfaces";
import NastaPill from "./NastaPill.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SignUp',
  setup(__props) {

const data = ref<{
  loading: boolean;
  classes: Class[];
}>({
  loading: true,
  classes: [],
});

const name = ref<string>("");

const surname = ref<string>("");

const phoneNumber = ref<string>("");

const drivingSchool = ref<string>("");

const errors = ref<{ [key: string]: string }>({});

const clearErrors = () => {
  errors.value = {};
  isUnknownError.value = false;
};

const nameError = computed(() => {
  return errors.value.name;
});

const surnameError = computed(() => {
  return errors.value.surname;
});

const phoneNumberError = computed(() => {
  return errors.value.phoneNumber;
});

const drivingSchoolError = computed(() => {
  return errors.value.drivingSchool;
});

const formatSpotsAvailable = (spots: false | number) => {
  if (spots === false || spots < 1) {
    return "Nema slobodnih mjesta";
  }

  if (spots === 1) {
    return "1 slobodno mjesto";
  }

  if (spots > 1 && spots < 5) {
    return `${spots} slobodna mjesta`;
  }

  return `${spots} slobodnih mjesta`;
};

const formatState = (
  availability: false | number,
  state: ClassState
): string => {
  switch (state) {
    case "upcoming":
      if (availability) {
        return "Prijave otvorene";
      }
      break;
    case "ongoing":
      return "Trenutno u tijeku";
    case "complete":
      return "Završeno";
    default:
      console.log("Unknown state", state);
  }

  return "";
};

const axios = inject("axios") as AxiosStatic;

const formIsSending = ref(false);

const formIsComplete = ref(false);

const isUnknownError = ref(false);

const formIsDisabled = computed(() => {
  return formIsSending.value || formIsComplete.value;
});

const formSubmit = (date: string) => {
  clearErrors();
  formIsSending.value = true;
  bookClass(axios, {
    classId: date,
    userInfo: {
      name: name.value,
      surname: surname.value,
      phoneNumber: phoneNumber.value,
      drivingSchool: drivingSchool.value,
    },
  }).then(
    () => {
      formIsSending.value = false;
      formIsComplete.value = true;
    },
    (error) => {
      formIsSending.value = false;
      if (error.response?.data?.issues) {
        errors.value = error.response?.data?.issues.reduce(
          (acc: { [key: string]: string }, issue: any) => {
            if (issue.path.length < 2) {
              console.error("Issue path is too short");
              return acc;
            }

            if (issue.path[0] !== "userInfo") {
              console.error("Issue path is not userInfo");
              return acc;
            }

            acc[issue.path[1]] = issue.message;
            return acc;
          },
          {}
        );
      } else {
        isUnknownError.value = true;
      }
    }
  );
};

getClasses(axios).then((classes) => {
  data.value = {
    loading: false,
    classes,
  };
});

return (_ctx: any,_cache: any) => {
  return (data.value.loading)
    ? (_openBlock(), _createBlock(NastaPill, {
        key: 0,
        kind: "short"
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }))
    : (data.value.classes.length > 0)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(data.value.classes, (firstAidClass) => {
          return (_openBlock(), _createBlock(NastaPill, {
            kind: "short",
            key: firstAidClass.id
          }, {
            "additional-content": _withCtx(() => [
              (firstAidClass.state === 'upcoming')
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(formatSpotsAvailable(firstAidClass.availability)), 1))
                : _createCommentVNode("", true),
              _hoisted_7,
              _hoisted_8,
              _createElementVNode("ul", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(firstAidClass.dates, (date) => {
                  return (_openBlock(), _createElementBlock("li", { key: date }, _toDisplayString(date), 1))
                }), 128))
              ]),
              _hoisted_10,
              (firstAidClass.availability)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_11,
                    _createElementVNode("form", {
                      onSubmit: _withModifiers(($event: any) => (!formIsDisabled.value && formSubmit(firstAidClass.id)), ["prevent"]),
                      class: _normalizeClass({ complete: formIsComplete.value }),
                      method: "POST"
                    }, [
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _withDirectives(_createElementVNode("input", {
                          id: "form-name",
                          type: "text",
                          name: "name",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
                          disabled: formIsDisabled.value
                        }, null, 8, _hoisted_15), [
                          [_vModelText, name.value]
                        ]),
                        (nameError.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(nameError.value), 1))
                          : _createCommentVNode("", true),
                        _hoisted_17,
                        _withDirectives(_createElementVNode("input", {
                          id: "form-surname",
                          type: "text",
                          name: "surname",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((surname).value = $event)),
                          disabled: formIsDisabled.value
                        }, null, 8, _hoisted_18), [
                          [_vModelText, surname.value]
                        ]),
                        (surnameError.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(surnameError.value), 1))
                          : _createCommentVNode("", true),
                        _hoisted_20,
                        _withDirectives(_createElementVNode("input", {
                          id: "form-phone-number",
                          type: "tel",
                          name: "phone-number",
                          disabled: formIsDisabled.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((phoneNumber).value = $event))
                        }, null, 8, _hoisted_21), [
                          [_vModelText, phoneNumber.value]
                        ]),
                        (phoneNumberError.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(phoneNumberError.value), 1))
                          : _createCommentVNode("", true),
                        _hoisted_23,
                        _withDirectives(_createElementVNode("input", {
                          id: "form-driving-school",
                          type: "string",
                          name: "driving-school",
                          disabled: formIsDisabled.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((drivingSchool).value = $event))
                        }, null, 8, _hoisted_24), [
                          [_vModelText, drivingSchool.value]
                        ]),
                        (drivingSchoolError.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(drivingSchoolError.value), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("button", {
                            class: "sign-up-btn",
                            disabled: formIsDisabled.value
                          }, [
                            (formIsComplete.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_28, "✓"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_29, "Upis"))
                          ], 8, _hoisted_27)
                        ]),
                        (drivingSchoolError.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(drivingSchoolError.value), 1))
                          : _createCommentVNode("", true)
                      ]),
                      (isUnknownError.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, " Došlo je do nepoznate greške, molimo pokušajte ponovo ili nas kontaktirajte. "))
                        : _createCommentVNode("", true)
                    ], 42, _hoisted_12)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createTextVNode(" Početak "),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(firstAidClass.dates[0]), 1)
                ]),
                _createElementVNode("div", _hoisted_5, _toDisplayString(formatState(firstAidClass.availability, firstAidClass.state)), 1)
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      : (_openBlock(), _createBlock(NastaPill, {
          key: 2,
          kind: "short"
        }, {
          default: _withCtx(() => [
            _hoisted_32
          ]),
          _: 1
        }))
}
}

})